module.exports = __webpack_public_path__ + "static/media/banner-bolsatrabajo.33877d36.png";